import React from 'react'
import { SvgIcon } from '../svg-icon'

const defaultProps = {
    viewBoxSize: 48
}

const ListIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M21,8c0,0.55-0.45,1-1,1H8C7.45,9,7,8.55,7,8l0,0c0-0.55,0.45-1,1-1h12C20.55,7,21,7.45,21,8L21,8z M4,7C3.45,7,3,7.45,3,8
            s0.45,1,1,1s1-0.45,1-1S4.55,7,4,7z M21,12c0-0.55-0.45-1-1-1H8c-0.55,0-1,0.45-1,1l0,0c0,0.55,0.45,1,1,1h12
            C20.55,13,21,12.55,21,12L21,12z M4,11c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1S4.55,11,4,11z M21,16c0-0.55-0.45-1-1-1H8
            c-0.55,0-1,0.45-1,1l0,0c0,0.55,0.45,1,1,1h12C20.55,17,21,16.55,21,16L21,16z M4,15c-0.55,0-1,0.45-1,1c0,0.55,0.45,1,1,1
            s1-0.45,1-1C5,15.45,4.55,15,4,15z`}
        />
    </SvgIcon>
)

ListIcon.defaultProps = defaultProps

export { ListIcon }
